import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "taggingButton"];

  remove(event) {
    const item = event.currentTarget.closest("[data-attachment-id]");
    const filename = item.dataset.filenameValue;
    const url = item.dataset.removeUrl;

    if (!confirm(`Remove file ${filename}?`)) return;

    fetch(url, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": this.csrfToken(),
        Accept: "application/json",
      },
    }).then((response) => {
      if (response.ok) {
        item.remove();
        const tagger_items = document.querySelectorAll(`[data-file-name='${filename}']`);
        tagger_items.forEach((d) => d.remove());
        this.checkEmptyState();
      } else {
        alert("Failed to remove document.");
      }
    });
  }

  checkEmptyState() {
    if (!this.hasListTarget) return;

    const remainingItems = this.listTarget.querySelectorAll("[data-attachment-id]");

    if (remainingItems.length === 0) {
      const emptyMessage = document.createElement("p");
      emptyMessage.className = "empty-state";
      emptyMessage.textContent = "No documents selected at this time.";
      this.listTarget.appendChild(emptyMessage);

      if (this.hasTaggingButtonTarget) {
        this.taggingButtonTarget.disabled = true;
      }
    }
  }

  csrfToken() {
    return document.querySelector("meta[name='csrf-token']").getAttribute("content");
  }
}
